import React, {useState, useEffect} from "react";
import classnames from "classnames";
import AltLogo from "../images/main-logo.svg";
import HamburgerMenu from "../images/hamburger-menu.svg";
import HamburgerMenuClose from "../images/hamburger-menu-close.svg";
import { NavLink, useLocation } from "react-router-dom";

const navLinkClass = ({ isActive }) =>
  classnames("nav-overlay-item", {
    "nav-overlay-item--accent": isActive,
    "nav-overlay-item--dark": !isActive,
  });

const NavOverlay = ({ menuOpen, onNavigate }) => {
    return (
        <div className={classnames("nav-overlay", {"show": menuOpen})}>
          <ul>
            <li>
              <NavLink className={navLinkClass} to="/" end onClick={onNavigate}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink className={navLinkClass} to="/work" onClick={onNavigate}>
                Our Work
              </NavLink>
            </li>
            <li>
              <NavLink className={navLinkClass} to="/photography" onClick={onNavigate}>
                Photography
              </NavLink>
            </li>
            <li>
              <NavLink className={navLinkClass} to="/about" onClick={onNavigate}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink className={navLinkClass} to="/contact" onClick={onNavigate}>
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
    );
};

const NavBar = () => {
    const [menuOpen, toggleMenuOverlay] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
      toggleMenuOverlay(false);
    }, [location.pathname]);

    useEffect(() => {
	const handleScroll = () => {
	    const isScrolled = window.scrollY > 30;
	    if (isScrolled !== scrolled) {
		setScrolled(isScrolled);
	    }
	};

	window.addEventListener('scroll', handleScroll);
	return () => window.removeEventListener('scroll', handleScroll);
    }, [scrolled]);

    useEffect(() => {
      if (!menuOpen) return;

      const handleKeyDown = (event) => {
        if (event.key === "Escape" || event.key === "Esc") {
          toggleMenuOverlay(false);
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }, [menuOpen]);

    return (
        <div className={classnames("nav-bar", {
            "scrolled": scrolled,
            "menu-open": menuOpen})}>
          <div className="container d-flex justify-content-between">
            <NavLink to="/" aria-label="Home">
              <img className="nav-logo" src={AltLogo} alt="Alvarez Branding Co." />
            </NavLink>
            <button
              type="button"
              className="btn p-0 nav-hamburger-btn"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              onClick={() => toggleMenuOverlay(!menuOpen)}
            >
              <img
                className={classnames("hamburger-menu", { "hamburger-menu--light": menuOpen })}
                src={menuOpen ? HamburgerMenuClose : HamburgerMenu}
                alt=""
              />
            </button>
          </div>
          {menuOpen && (
            <div
              className="nav-backdrop"
              onClick={() => toggleMenuOverlay(false)}
              aria-hidden="true"
            />
          )}
          <NavOverlay menuOpen={menuOpen} onNavigate={() => toggleMenuOverlay(false)} />
        </div>
    )
}

export default NavBar
